import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "./AuthProvider";
import { takeReturnPath } from "./returnPath";

import { LoadingScreen } from "@/shared/components/LoadingScreen";

export function AuthCompletePage() {
  const { refreshSession } = useAuth();
  const navigate = useNavigate();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    void refreshSession().then((session) => {
      console.log("AuthCompletePage: session refreshed", session);
      if (!session?.isAuthenticated || !session.activeTenant)
        return navigate("/auth/error?code=SESSION_NOT_ESTABLISHED", {
          replace: true,
        });
      navigate(takeReturnPath() ?? `/app/${session.activeTenant.id}`, {
        replace: true,
      });
    });
  }, [navigate, refreshSession]);

  return <LoadingScreen label="Finishing sign in…" />;
}
